








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { IllnessTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxIllnessType extends Vue {
  private types: IllnessTypeDto[] | null = [];
  public selectedType = new IllnessTypeDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: IllnessTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: IllnessTypeDto) {
    this.$emit("illnessTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .illnessType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
